import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { HttpService } from './http.service';
import { MessageService } from './message.service';
import { catchError, EMPTY, NEVER, Observable, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private http: HttpService,
    private message: MessageService,
    private dialog: MatDialog
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 400) {
          this.message.error('参数错误');
        } else if (err.status === 401) {
          this.router.navigateByUrl('/login');
          this.http.reset();
          this.dialog.closeAll();
          return NEVER;
        } else if (err.status === 403) {
          this.message.error('无权访问该接口');
        } else if (err.status === 404) {
          /* 404 不处理 */
        } else if (err.status === 500) {
          this.message.error('服务器错误');
        } else {
          this.message.error('网络错误');
        }
        return EMPTY;
      })
    );
  }
}
